module.exports = __webpack_public_path__ + "static/media/logo.b9ae50ec.jpg";